import { Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import PageContainer from '../../components/PageContainer';
import TopBar from '../../components/TopBar';
import { useStyles } from './styles';
import BottomBar from '../../components/BottomBar';
import waveBottomImg from '../../assets/wave2.png';
import { useEffect } from 'react';
import { useTheme } from '../../hooks/useTheme';

function Phones() {
  const classes = useStyles();
  const { changeTheme } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
    changeTheme();
  }, [])

  function createData(service, number, font) {
    return { service, number, font };
  }
  const rows = [
    createData("Disque Direitos Humanos", "100 (tecle a opção 3 para denúncia de violência contra a pessoa idosa)", "https://www.gov.br/mdh/pt-br/acesso-a-informacao/disque-100" ),
    createData("Portal de Atendimento da Prefeitura de São Paulo ", "156", "https://sp156.prefeitura.sp.gov.br/portal/servicos#ouvidoria" ),
    createData("Meu INSS - Central", "135", "https://www.gov.br/previdencia/pt-br/assuntos/noticias/previdencia/inss/servico-central-135-modifica-opcoes-de-atendimento" ),
    createData("Corpo de Bombeiros", "193", "https://www.gov.br/pt-br/servicos-estaduais/acionar-corpo-de-bombeiros-193-1" ),
    createData("SAMU - Serviço de Atendimento Móvel de Urgência", "192", "https://www.gov.br/saude/pt-br/acesso-a-informacao/acoes-e-programas/samu" ),
  ]

  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Telefones Úteis
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Aqui você tem acesso a números de telefones úteis relacionados a pessoa idosa.
          </Typography>
          <div className={classes.container}>
            <TableContainer component={Paper}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Serviço</TableCell>
                    <TableCell>Número</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.service}>
                      <TableCell component="th" scope="row">
                        <Link href={row.font} target="_blank">{row.service}</Link>
                      </TableCell>
                      <TableCell>{row.number}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Phones;